var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	296510: {
		fallback: function() { return function() { return __webpack_require__(440961); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",

	},
	620562: {
		fallback: function() { return function() { return __webpack_require__(296540); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.3.1",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",

	},
	175410: {
		fallback: function() { return Promise.all([__webpack_require__.e(743), __webpack_require__.e(569)]).then(function() { return function() { return __webpack_require__(132196); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=11.7.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/css",

	},
	938033: {
		fallback: function() { return __webpack_require__.e(648).then(function() { return function() { return __webpack_require__(648648); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=0.3.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@contrast-security-inc/design-system-alerts",

	},
	260712: {
		fallback: function() { return function() { return __webpack_require__(41337); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "3.39.3",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-query",

	},
	282893: {
		fallback: function() { return function() { return __webpack_require__(575431); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "6.30.3",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",

	},
	355797: {
		fallback: function() { return Promise.all([__webpack_require__.e(705), __webpack_require__.e(716)]).then(function() { return function() { return __webpack_require__(49716); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=2.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@contrast-security-inc/design-system-foundations",

	},
	636136: {
		fallback: function() { return __webpack_require__.e(785).then(function() { return function() { return __webpack_require__(349785); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.72.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-hook-form",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [296510,620562];
__webpack_require__.federation.installInitialConsumes = function(options) { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"193": [
		636136
	],
	"410": [
		175410
	],
	"540": [
		938033,
		260712,
		282893
	],
	"547": [
		296510,
		620562
	],
	"797": [
		355797
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}